module.exports = __webpack_public_path__ + "static/media/doctor.cc3ed6f0.svg";